import { apiUrl } from "utils/apiUrl";

/** Admin API calls — sends signed HttpOnly admin cookie (credentials). */
export function adminFetch(path, options = {}) {
  const headers = { ...options.headers };
  if (
    options.body != null &&
    typeof options.body === "string" &&
    !headers["Content-Type"] &&
    !headers["content-type"]
  ) {
    headers["Content-Type"] = "application/json";
  }
  return fetch(apiUrl(path), {
    ...options,
    credentials: "include",
    headers,
  });
}
